import { isEmpty, isUndefined, set } from 'lodash'
import { defaultExportMenu, getColumnSeries } from '../helpers'

export default ({ config, data, color }) => {
  const { labelColor } = color
  const { series, ...restConfig } = config
  const {
    title,
    xKey,
    scrollbar,
    disabledLegend = false,
    removeLegend,
    labelsRotation,
    xTitle,
    axisRanges,
    exportingMenu,
    disabledAnimations = false
  } = restConfig

  const configuration = {
    data: data,
    type: 'XYChart',
    series: [
      getColumnSeries({
        series,
        otherConfig: { color, disabledAnimations, ...restConfig }
      })
    ],
    cursor: {},
    scrollbarX: {
      disabled: !scrollbar,
      parent: 'bottomAxesContainer'
    },
    xAxes: [
      {
        type: 'CategoryAxis',
        dataFields: {
          category: xKey
        },
        title: {
          text: xTitle || null,
          fill: labelColor
        },
        rangeChangeDuration: 500,
        renderer: {
          labels: {
            rotation: !isUndefined(labelsRotation) ? labelsRotation : -60,
            fill: labelColor
          },
          grid: {
            template: {
              strokeWidth: 0,
              fill: labelColor
            }
          },
          line: {
            strokeOpacity: 0.3,
            fill: labelColor
          },
          minGridDistance: 60,
          cellStartLocation: 0.1,
          cellEndLocation: 0.7,
          maxLabelPosition: 0.98
        }
      }
    ],
    yAxes: [
      {
        title: {
          text: title || null,
          fill: labelColor
        },
        axisRanges: !isEmpty(axisRanges) && [
          {
            value: axisRanges?.value,
            grid: {
              stroke: axisRanges?.color || labelColor,
              strokeWidth: 1,
              strokeOpacity: 1,
              strokeDasharray: axisRanges?.strokeDasharray || 0,
              above: true
            },
            label: {
              text: axisRanges?.text,
              inside: true,
              fill: axisRanges?.textColor || labelColor,
              verticalCenter: 'bottom',
              paddingBottom: 3
            }
          }
        ],
        id: 'CommonYAxis',
        type: 'ValueAxis',
        renderer: {
          line: {
            strokeOpacity: 0.3,
            fill: labelColor
          },
          labels: {
            fill: labelColor
          }
        }
      },
      {
        type: 'ValueAxis',
        renderer: {
          opposite: true,
          line: {
            strokeOpacity: 0,
            fill: labelColor
          },
          labels: {
            fill: labelColor
          }
        }
      }
    ],
    legend: {
      useDefaultMarker: true,
      disabled: disabledLegend,
      labels: {
        text: '{category}',
        fill: labelColor
      },
      contentAlign: 'left',
      paddingTop: 10,
      paddingLeft: 45,
      markers: {
        children: [
          {
            width: 20,
            height: 20,
            fontSize: 200,
            strokeWidth: 0,
            paddingTop: 2.5,
            marginLeft: 22.5,
            paddingLeft: 2.5,
            strokeOpacity: 0,
            paddingRight: 2.5,
            paddingBottom: 2.5,
            cornerRadiusTopLeft: 0,
            cornerRadiusTopRight: 0,
            cornerRadiusBottomLeft: 0,
            cornerRadiusBottomRight: 0
          }
        ]
      }
    }
  }
  if (removeLegend) {
    delete configuration.legend
  }

  if (labelsRotation && labelsRotation !== 0) {
    set(configuration.xAxes[0], 'renderer.labels.horizontalAlignment', 'middle')
  } else {
    set(configuration.xAxes[0], 'renderer.labels.horizontalCenter', 'right')
    set(configuration.xAxes[0], 'renderer.labels.verticalCenter', 'left')
  }

  // Export menu
  if (exportingMenu && exportingMenu.enabled) {
    if (isEmpty(exportingMenu.config)) {
      configuration.exporting = defaultExportMenu
    } else {
      configuration.exporting = exportingMenu.config
    }
  }
  return configuration
}
